import React from 'react';
import { Button, Dropdown, MenuProps } from 'antd';
import { ViewType } from '@restore/ExternalUserView/externalUserView.slice';

interface ViewSelectorProps {
  selectedView: ViewType;
  onChange: (view: ViewType) => void;
}

export const ViewSelector: React.FC<ViewSelectorProps> = ({
  selectedView,
  onChange,
}) => {
  const items: MenuProps['items'] = [
    {
      label: (
        <div className='flex items-center gap-2'>
          <div className='w-2 h-2'>
            {selectedView === ViewType.EXTERNAL && (
              <div className='w-2 h-2 rounded-full bg-green-500' />
            )}
          </div>
          <span>External user view</span>
        </div>
      ),
      key: ViewType.EXTERNAL,
      onClick: () => onChange(ViewType.EXTERNAL),
    },
    {
      label: (
        <div className='flex items-center gap-2'>
          <div className='w-2 h-2'>
            {selectedView === ViewType.SECONDARY && (
              <div className='w-2 h-2 rounded-full bg-green-500' />
            )}
          </div>
          <span>Secondary Access view</span>
        </div>
      ),
      key: ViewType.SECONDARY,
      onClick: () => onChange(ViewType.SECONDARY),
    },
  ];

  const currentViewLabel =
    selectedView === ViewType.EXTERNAL ? 'External user view' : 'Secondary Access view';

  return (
    <Dropdown menu={{ items }} trigger={['click']}>
      <Button
        type='text'
        className='flex items-center justify-center gap-2 px-3 py-2 hover:bg-gray-50'
      >
        <div className='w-2 h-2 rounded-full bg-green-500' />
        <span className='text-1424 font-medium'>{currentViewLabel}</span>
      </Button>
    </Dropdown>
  );
};
